import { api, publicApi } from './axios';

const PLATFORM_RULES_BASE = '/platform-rules';

const validateId = (id) => {
    if (!id) throw new Error('Platform rule ID is required');
};

/**
 * Категории платформенных правил
 */
export const PLATFORM_RULE_CATEGORIES = {
    COMMUNITY_GUIDELINES: 'Правила сообщества',
    TERMS_OF_SERVICE: 'Условия использования',
    CONTENT_POLICY: 'Политика контента',
    PRIVACY_POLICY: 'Политика конфиденциальности',
    CODE_OF_CONDUCT: 'Кодекс поведения',
};

export const platformRulesApi = {
    /**
     * Публичный список активных правил (без авторизации)
     * @param {Object} params — { category, page, size, sortBy, direction }
     * @returns {Promise<Object>} Page<PlatformRuleResponse>
     */
    listPublic: async (params = {}) => {
        try {
            const { data } = await publicApi.get(`${PLATFORM_RULES_BASE}/public`, { params });
            return data;
        } catch (error) {
            console.error('[platformRulesApi.listPublic] Failed:', error.message);
            throw error;
        }
    },

    /**
     * Полный список правил (требует авторизации)
     * @param {Object} params — { category, page, size, sortBy, direction }
     * @returns {Promise<Object>} Page<PlatformRuleResponse>
     */
    list: async (params = {}) => {
        try {
            const { data } = await api.get(PLATFORM_RULES_BASE, { params });
            return data;
        } catch (error) {
            console.error('[platformRulesApi.list] Failed:', error.message);
            throw error;
        }
    },

    /**
     * Получить правило по ID (требует авторизации)
     * @param {string} id — UUID правила
     * @returns {Promise<Object>} PlatformRuleResponse
     */
    get: async (id) => {
        validateId(id);
        try {
            const { data } = await api.get(`${PLATFORM_RULES_BASE}/${id}`);
            return data;
        } catch (error) {
            console.error(`[platformRulesApi.get] Failed for ${id}:`, error.message);
            throw error;
        }
    },

    /**
     * Создать правило (только ADMIN)
     * @param {Object} payload — { category, title, text, sortOrder?, isActive? }
     * @returns {Promise<Object>} PlatformRuleResponse
     */
    create: async (payload) => {
        if (!payload) throw new Error('Payload is required');
        try {
            const { data } = await api.post(PLATFORM_RULES_BASE, payload);
            return data;
        } catch (error) {
            console.error('[platformRulesApi.create] Failed:', error.message);
            throw error;
        }
    },

    /**
     * Обновить правило (только ADMIN)
     * @param {string} id — UUID правила
     * @param {Object} payload — { category, title, text, sortOrder?, isActive? }
     * @returns {Promise<Object>} PlatformRuleResponse
     */
    update: async (id, payload) => {
        validateId(id);
        if (!payload) throw new Error('Update payload is required');
        try {
            const { data } = await api.put(`${PLATFORM_RULES_BASE}/${id}`, payload);
            return data;
        } catch (error) {
            console.error(`[platformRulesApi.update] Failed for ${id}:`, error.message);
            throw error;
        }
    },

    /**
     * Переключить активность правила (только ADMIN)
     * @param {string} id — UUID правила
     * @returns {Promise<Object>} PlatformRuleResponse
     */
    toggle: async (id) => {
        validateId(id);
        try {
            const { data } = await api.patch(`${PLATFORM_RULES_BASE}/${id}/toggle`);
            return data;
        } catch (error) {
            console.error(`[platformRulesApi.toggle] Failed for ${id}:`, error.message);
            throw error;
        }
    },

    /**
     * Удалить правило (только ADMIN)
     * @param {string} id — UUID правила
     * @returns {Promise<void>}
     */
    remove: async (id) => {
        validateId(id);
        try {
            await api.delete(`${PLATFORM_RULES_BASE}/${id}`);
        } catch (error) {
            console.error(`[platformRulesApi.remove] Failed for ${id}:`, error.message);
            throw error;
        }
    },
};
